const TOPICS_CONSTANTS = {
	SELECTED_FIELDS: 'selectedFields',
};

const subscribers: Record<string, Array<(data: string | null) => void>> = {};

function publish(topic: string, message: string | null) {
	if (!Array.isArray(subscribers[topic])) {
		return;
	}
	subscribers[topic].forEach((callback) => callback(message));
}

function subscribe(topic: string, callback: (data: string | null) => void) {
	if (!Array.isArray(subscribers[topic])) {
		subscribers[topic] = [];
	}
	const index = subscribers[topic].push(callback) - 1;
	return {
		unsubscribe() {
			subscribers[topic].splice(index, 1);
		},
	};
}

function clear(topic: string) {
	if (subscribers[topic]) publish(topic, null);
}

export { publish, subscribe, clear, TOPICS_CONSTANTS };
